/**
 * 字符串中包含需要高亮的链接，通过正则匹配，转成数组
 */
const switchHighlightTextStrToArray = ({
  textStr,
  regUrl,
}: {
  textStr: string;
  regUrl: string;
}) => {
  const reg = new RegExp(regUrl, "g");
  let textArr: any = [];
  let matchTemp;
  let endIndex = 0; // 上一个匹配结果的最后字符索引

  // 匹配所有满足正则的结果
  while ((matchTemp = reg.exec(textStr))) {
    if (matchTemp.groups) {
      const { pretitle = "", url, title = "", type, guid } = matchTemp.groups;

      // 《pretitle》 https://yach-doc-shimo-test.zhiyinlou.com/docs/PdYHWDvj9XpcyWpk/  <title>
      // 优先使用 《title》
      let docName = title.replace(/^</, "《").replace(/>$/, "》");
      let prevTextEndIndex = matchTemp.index + pretitle.length;

      if (!docName && pretitle) {
        docName = pretitle.replace(/^</, "《").replace(/>$/, "》");
        prevTextEndIndex = matchTemp.index;
      }

      const prevText = textStr.slice(endIndex, prevTextEndIndex);
      if (prevText) {
        textArr.push({
          isLink: false,
          url: "",
          text: prevText,
        });
      }

      // e.g. https://yach-doc-shimo-test.zhiyinlou.com/docs/PdYHWDvj9XpcyWpk/  <会议模板（好未来大学）>
      // guid: PdYHWDvj9XpcyWpk
      // docType: 根据 docs 转换的类型
      textArr.push({
        isLink: true,
        url,
        docType: getShiMoDocType(type),
        guid,
        text: docName || getDefaultTitle(url),
      });

      endIndex = reg.lastIndex;
    }
  }

  const nextText = textStr.slice(endIndex);
  if (nextText) {
    textArr.push({
      isLink: false,
      url: "",
      text: nextText,
    });
  }

  return {
    textArr,
  };
};

/**
 * 获取在线文档类型，主要用于绑定和解绑文档消息
 * @param {String} key
 */
const getShiMoDocType = (key: string) => {
  switch (key) {
    case "docs":
      return "newdoc";
    case "sheets":
      return "mosheet";
    case "forms":
      return "form";
    case "mindmaps":
      return "mindmap";
    case "slides":
    case "presentation":
      return "slide";
    default:
      return "";
  }
};

/**
 * 链接识别获取默认标题
 * @param {String} url
 * @returns
 */
const getDefaultTitle = (url: string) => {
  const { isShimoUrl } = checkHighlightUrlType(url);

  if (isShimoUrl) {
    return "《知音楼在线文档》";
  }

  return "";
};

/**
 * 根据链接判断类型
 * @param {*} url
 */
const checkHighlightUrlType = (url: string) => {
  const res = {
    isShimoUrl: false,
  };

  if (!url) {
    return res;
  }

  const shimoHostArr = [
    "yach-doc-shimo-test.zhiyinlou.com",
    "yach-doc-shimo.zhiyinlou.com",
  ];
  let shimoUrl = shimoHostArr.filter((item) => url.includes(item));
  if (shimoUrl?.length) {
    res.isShimoUrl = true;
    return res;
  }

  return res;
};

export { switchHighlightTextStrToArray };
